export default __webpack_public_path__ + "static/media/Message.959f8af4.svg";